import React from 'react'

const StatisticsTableRow = ({ site }) => {
    const totalCharts = Object.keys(site).reduce((accumulator, currentValue) => {
        const skipFields = [
            'adverse drug reactions',
            'ineligible',
            'site_country',
            'site_name',
            'site_number',
        ]

        if (skipFields.includes(currentValue)) {
            return accumulator
        }

        return accumulator + (Number(site[currentValue]) || 0)
    }, 0)

    return (
        <tr>
            <td className="sticky-col col-one">
                {site.site_country || 0}
            </td>

            <td className="sticky-col col-two">
                {site.site_number ?
                    `${site.site_number} - ${site.site_name}` :
                    site.site_name
                }
            </td>

            <td>
                {site['incomplete'] || 0}
            </td>

            <td>
                {site['approved'] || 0}
            </td>

            <td>
                {site['pending investigator review'] || 0}
            </td>

            <td>
                {site['requires revisions'] || 0}
            </td>

            <td>
                {site['pending data manager review'] || 0}
            </td>

            <td>
                {site['pending data validation'] || 0}
            </td>

            <td>
                {site['ineligible'] || 0}
            </td>

            <td>
                {site['adverse drug reactions'] || 0}
            </td>

            <td>
                {totalCharts}
            </td>
        </tr>
    )
}

export default StatisticsTableRow